import { Popover, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import { Button as EditorButton } from '~components/generic/editor/Button/Button';
import { Hint } from '~components/generic/editor/Hint/Hint';
import { DeleteIcon } from '~components/icons';
import useLabels from '~hooks/useLabels';

export function DeleteItemPopover({ onDelete }: { onDelete: () => void }) {
  const {
    btnChangelogItemDelete,
    btnChangelogItemDeleteConfirm,
    btnChangelogItemDeleteCancel,
    msgChangelogItemDelete,
  } = useLabels([
    'btnChangelogItemDelete',
    'btnChangelogItemDeleteConfirm',
    'btnChangelogItemDeleteCancel',
    'msgChangelogItemDelete',
  ]);
  return (
    <Popover className={`relative flex`}>
      {({ open, close }) => (
        <>
          <Popover.Button as={EditorButton} title={btnChangelogItemDelete} icon={<DeleteIcon />} disabled={open} />
          <Transition
            show={open}
            as={Fragment}
            enter={`transition ease-out duration-200`}
            enterFrom={`opacity-0 -translate-y-1`}
            enterTo={`opacity-100 translate-y-0`}
            leave={`transition ease-in duration-150`}
            leaveFrom={`opacity-100 translate-y-0`}
            leaveTo={`opacity-0 -translate-y-1`}
          >
            <Popover.Panel as={Hint} className={`absolute z-50 mt-3 transform left-0 bottom-0`}>
              <div className={`block`}>
                <div>{msgChangelogItemDelete}</div>
                <div className={`mt-4 flex justify-end`}>
                  <EditorButton onClick={() => close()} label={btnChangelogItemDeleteCancel} />
                  <div className="mx-2" />
                  <EditorButton icon={<DeleteIcon />} onClick={onDelete} label={btnChangelogItemDeleteConfirm} />
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
